import type { FacebookInitConfig } from './types';

const FB_APP_ID = import.meta.env.VITE_FB_APP_ID;

if (!FB_APP_ID) {
  console.warn('VITE_FB_APP_ID environment variable is not set');
}

export const FACEBOOK_SDK_CONFIG: FacebookInitConfig = {
  appId: FB_APP_ID || '',
  xfbml: true,
  version: 'v25.0',
} as const;

export const FB_SDK_INIT_TIMEOUT_MS = 5000;

export const FB_LOGIN_CONFIG_ID = '434840172860037';

export const FACEBOOK_CONFIG = {
  sdkConfig: FACEBOOK_SDK_CONFIG,
} as const;
